module.exports = __webpack_public_path__ + "img/材料力学1_7_2.618fd071.jpg";